import { isAllowedLang, type LanguageIsoCode } from 'locales';

export function sanitizeLocaleCode(locale: string): LanguageIsoCode {
  if (isAllowedLang(locale)) {
    return locale;
  }
  return 'en';
}
